function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DebatersTemplate = require('./debaters.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DebatersOverlay = /*#__PURE__*/function () {
  function DebatersOverlay(app, mod) {
    _classCallCheck(this, DebatersOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(DebatersOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.visible = true;
      this.overlay.show(DebatersTemplate());
      for (var i = 0; i < this.mod.game.state.debaters.length; i++) {
        var committed = '';
        if (this.mod.game.state.debaters[i].committed == 1) {
          committed = ' debater-commited';
        }
        this.app.browser.addElementToSelector("<div class=\"debaters-tile debaters-tile".concat(i, " ").concat(committed, "\" data-key=\"").concat(this.mod.game.state.debaters[i].key, "\" data-id=\"").concat(this.mod.game.state.debaters[i].img, "\" style=\"background-image:url('/his/img/tiles/debaters/").concat(this.mod.game.state.debaters[i].img, "')\"></div>"), '.debaters-overlay');
      }
      var _loop = function _loop() {
        var tile_f = '/his/img/tiles/debaters/' + _this.mod.game.state.debaters[_i].img;
        var tile_b = tile_f.replace('.svg', '_back.svg');
        var divsq = ".debaters-tile".concat(_i);
        $(divsq).mouseover(function () {
          $(this).css('background-image', "url('".concat(tile_b, "')"));
        }).mouseout(function () {
          $(this).css('background-image', "url('".concat(tile_f, "')"));
        });
      };
      for (var _i = 0; _i < this.mod.game.state.debaters.length; _i++) {
        _loop();
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var overlay_self = this;
      var his_self = this.mod;
      var protestant_player = his_self.returnPlayerOfFaction('protestant');
      var papacy_player = his_self.returnPlayerOfFaction('papacy');
      if (his_self.game.player != protestant_player && his_self.game.player != papacy_player) {
        return;
      }
      var faction = 'protestant';
      if (his_self.game.player === papacy_player) {
        faction = 'papacy';
      }
      for (var i = 0; i < his_self.game.state.debaters.length; i++) {
        var divsq = ".debaters-tile".concat(i);
        var tile_f = '/his/img/tiles/debaters/' + his_self.game.state.debaters[i].img;
        var tile_b = tile_f.replace('.svg', '_back.svg');

        //
        //
        //
        //$(divsq).click(function() {
        //
        // let key = $(this).attr("data-key");
        //
        //  if (his_self.game.state.debaters[i].committed == 0 && his_self.canPlayerCommitDebater(faction, key)) {
        //    alert("Commiting Debater for Bonus");
        //    his_self.commitDebater(faction, key, 1);
        //    his_self.addMove("commit\t"+faction+"\t"+key);
        //    his_self.endTurn();
        //    $(this).css('background-image', `url('${tile_b}')`);
        //    overlay_self.render();
        //  } else {
        //    alert("cannot commit debater now");
        //  }
        //});
        //
      }
    }
  }]);
}();
module.exports = DebatersOverlay;